/**
 * @format
 * @Description: 手工推送消息状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Utils from 'utils';
import { filter, get } from 'lodash';

const CDN_BASE = 'assets';
useStrict(true);
class ManuallySendMod {
  @observable
  listVersion = '';

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }
  getListBeforeRequest(data) {
    let obj = {};
    let updateTimeBegin = get(data, ['sendTime', '0', '_d'])
      ? Utils.timeFormat(get(data, ['sendTime', '0', '_d']))
      : '';
    let updateTimeEnd = get(data, ['sendTime', '1', '_d']) ? Utils.timeFormat(get(data, ['sendTime', '1', '_d'])) : '';
    if (data.sendTime) {
      obj.updateTimeBegin = updateTimeBegin || undefined;
      obj.updateTimeEnd = updateTimeEnd || undefined;
    }
    obj.pageNum = data.pageNum;
    obj.pageSize = data.pageSize;
    obj.code = data.code || undefined;
    obj.eventName = data.eventName || undefined;
    obj.triggerType = '0';
    return obj;
  }
  getListAfterRequest(data) {
    data.list = filter(data.list, item => {
      if (item.triggerType == 0) {
        return item;
      }
    });
    return data;
  }
}

// ES6单例写法
export default new ManuallySendMod();



// WEBPACK FOOTER //
// ./src/pages/MessageManage/ManuallySend/ManuallySendMod.js